var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVisaIcon = function SvgVisaIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 30,
    fill: "none",
    viewBox: "0 0 50 30"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 30,
    fill: "#F5F7FA",
    rx: 5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0058A0",
    d: "m19.332 20.455 1.771-10.276h2.835l-1.774 10.276zM32.443 10.432a7.4 7.4 0 0 0-2.54-.432c-2.8 0-4.773 1.395-4.79 3.392-.016 1.476 1.407 2.3 2.483 2.792 1.104.504 1.47.825 1.47 1.274-.008.69-.882 1.003-1.696 1.003-1.134 0-1.736-.155-2.667-.539l-.361-.162-.403 2.3c.662.29 1.885.535 3.157.547 2.98 0 4.912-1.376 4.935-3.51.01-1.169-.744-2.058-2.378-2.792-.992-.476-1.6-.792-1.593-1.274 0-.427.514-.884 1.624-.884a5.3 5.3 0 0 1 2.12.394l.255.119zM39.71 10.19h-2.19c-.679 0-1.187.183-1.485.851l-4.207 9.418h2.975s.485-1.266.597-1.544l3.628.005c.083.36.344 1.54.344 1.54h2.63l-2.294-10.272zm-3.495 6.623c.234-.592 1.128-2.873 1.128-2.873-.016.027.233-.595.377-.981l.196.886.656 2.968zM16.954 10.187l-2.775 7.008-.294-1.424c-.516-1.648-2.125-3.42-3.922-4.311l2.533 8.988h2.998l4.461-10.261z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FAA61A",
    d: "M11.606 10.177H7.034L7 10.39c3.555.852 5.908 2.907 6.883 5.377l-.993-4.718c-.17-.65-.669-.845-1.284-.872"
  })));
};
export default SvgVisaIcon;